import React from "react";

export const CustomLogin: React.FC = () => {
  return <>Custom login component</>;
};
